"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isObject;
var objectConstructor = {}.constructor;

function isObject(object) {
  return object !== undefined && object !== null && object.constructor === objectConstructor;
}
//# sourceMappingURL=isObject.js.map


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/build/helpers/isObject.js
// module id = 243
// module chunks = 0